module.exports = __webpack_public_path__ + "img/question-two.db8ee001.jpg";